import { render, staticRenderFns } from "./TitBar.vue?vue&type=template&id=5612fc96&scoped=true"
import script from "./TitBar.vue?vue&type=script&lang=js"
export * from "./TitBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5612fc96",
  null
  
)

export default component.exports